import { FC } from 'react';

import { Home } from '@/components/Home';

export const HomePage: FC = () => <Home />;

export default HomePage;
